export enum AdminImportValidation {
  VALID,
  INVALID,
  WARNING,
}

export namespace AdminImportValidation {
  let elements = [
    AdminImportValidation.VALID,
    AdminImportValidation.INVALID,
    AdminImportValidation.WARNING,
  ];
  let alias = "com.bcdfx.model.common.api.enums.AdminImportValidation";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
